
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Download, RefreshCw } from 'lucide-react';

interface CourierActivityFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  activityFilter: string;
  setActivityFilter: (filter: string) => void;
  paymentsFilter: string;
  setPaymentsFilter: (filter: string) => void;
  onRefresh: () => void;
  onExport: () => void;
  loading: boolean;
}

const CourierActivityFilters: React.FC<CourierActivityFiltersProps> = ({
  searchTerm,
  setSearchTerm,
  activityFilter,
  setActivityFilter,
  paymentsFilter,
  setPaymentsFilter,
  onRefresh,
  onExport,
  loading
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          placeholder="Поиск по имени курьера..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>
      
      <Select value={activityFilter} onValueChange={setActivityFilter}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Уровень активности" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Все уровни</SelectItem>
          <SelectItem value="super">Супер активные (5+)</SelectItem>
          <SelectItem value="high">Высокая активность (4)</SelectItem>
          <SelectItem value="good">Хорошая активность (2-3)</SelectItem>
          <SelectItem value="medium">Средняя активность (1)</SelectItem>
          <SelectItem value="low">Низкая активность (0)</SelectItem>
        </SelectContent>
      </Select>

      <Select value={paymentsFilter} onValueChange={setPaymentsFilter}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Количество платежей" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Все</SelectItem>
          <SelectItem value="1-5">1-5 платежей</SelectItem>
          <SelectItem value="6-10">6-10 платежей</SelectItem>
          <SelectItem value="11-20">11-20 платежей</SelectItem>
          <SelectItem value="20+">20+ платежей</SelectItem>
        </SelectContent>
      </Select>

      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={loading}>
          <RefreshCw className="h-4 w-4 mr-1" />
          Обновить
        </Button>
        
        <Button variant="outline" size="sm" onClick={onExport}>
          <Download className="h-4 w-4 mr-1" />
          Экспорт
        </Button>
      </div>
    </div>
  );
};

export default CourierActivityFilters;
